import { useAppSelector } from "@/stores/hook";
import LeadSourceViewMode from "./LeadSourceViewMode";
import LeadSourceEditMode from "./LeadSourceEditMode";

export default function LeadSourceSection() {
  const { isEditMode } = useAppSelector((state) => state.leadFunctional);

  if (isEditMode) {
    return <LeadSourceEditMode />;
  }

  return <LeadSourceViewMode />;
}
